import { isValidElement, type ReactNode } from 'react';

export const isReactNode = (prefixIcon: ReactNode): boolean => {
  return isValidElement(prefixIcon);
};
